import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import ConfiguracionAsignacion from "./ConfiguracionAsignacion.js";

const campoConfig = (tipo) => `config_${tipo.codigo ?? tipo.descripcion}`;

const estadoPorTipo = (cliente, tipo) => {
  const valores = Array.isArray(cliente.configuracionPredeterminada)
    ? cliente.configuracionPredeterminada
    : [];
  const item = valores.find(
    (c) =>
      c.codigo === tipo.codigo ||
      (tipo.codigo == null && c.descripcion === tipo.descripcion)
  );
  if (!item) {
    return "Sin definir";
  }
  // Esquema de cantidad dinámica: se muestran los documentos a emitir por
  // tipo; filas legacy sin cantidad quedan como "Separadas"
  const cantidad = Number(item.cantidadDocumentos);
  return cantidad > 0 ? `${cantidad} documento${cantidad === 1 ? "" : "s"}` : "";
};

const AgrupacionTable = ({
  clientes,
  loading,
  catalogo,
  expandedRows,
  onRowToggle,
  onRowClick,
  onConfigurar,
  header,
}) => {
  const catalogoTipos = Array.isArray(catalogo) ? catalogo : [];

  const clientesComputed = Array.isArray(clientes)
    ? clientes.map((cliente) => ({
        ...cliente,
        // Clave única por fila: las combinaciones (cliente, empresa) comparten
        // el id del cliente y un dataKey repetido duplica/omite filas en React
        claveFila: `${cliente.id}#${cliente.idEmpresa ?? cliente.empresa ?? ""}`,
        cantidad_asignaciones: Array.isArray(cliente.asignaciones)
          ? cliente.asignaciones.length
          : 0,
        ...Object.fromEntries(
          catalogoTipos.map((tipo) => [
            campoConfig(tipo),
            estadoPorTipo(cliente, tipo),
          ])
        ),
      }))
    : [];

  const asignacionesBodyTemplate = (rowData) => (
    <strong>{rowData.cantidad_asignaciones}</strong>
  );

  const expansionTemplate = (cliente) => {
    const asignaciones = Array.isArray(cliente.asignaciones)
      ? cliente.asignaciones
      : [];
    if (asignaciones.length === 0) {
      return (
        <div className="p-3 text-600">
          El cliente no tiene asignaciones activas.
        </div>
      );
    }
    return (
      <div className="p-3">
        {asignaciones.map((asignacion) => (
          <ConfiguracionAsignacion
            key={asignacion.id}
            asignacion={asignacion}
            catalogo={catalogoTipos}
          />
        ))}
      </div>
    );
  };

  return (
    <DataTable
      header={header}
      value={clientesComputed}
      className="p-datatable-gridlines"
      showGridlines
      paginator
      rows={10}
      rowsPerPageOptions={[10, 20, 50, 100]}
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} clientes"
      dataKey="claveFila"
      emptyMessage="No se encontraron clientes con asignaciones."
      stripedRows="true"
      expandedRows={expandedRows}
      onRowToggle={onRowToggle}
      onRowClick={onRowClick}
      rowExpansionTemplate={expansionTemplate}
      tableStyle={{ tableLayout: "fixed", width: "100%" }}
      scrollable
      scrollHeight="57vh"
    >
      <Column expander style={{ width: "3rem" }} />
      <Column
        field="alias"
        header="Alias"
        sortable
        style={{ minWidth: "8rem" }}
        body={(rowData) => rowData.alias ?? "Sin alias"}
      />
      <Column
        field="empresa"
        header="Empresa"
        sortable
        style={{ minWidth: "8rem" }}
        body={(rowData) => rowData.empresa ?? "—"}
      />
      <Column
        field="cantidad_asignaciones"
        header="Asignaciones"
        sortable
        style={{ minWidth: "7rem" }}
        body={asignacionesBodyTemplate}
      />
      {catalogoTipos.map((tipo) => (
        <Column
          key={tipo.codigo ?? tipo.descripcion}
          field={campoConfig(tipo)}
          header={tipo.descripcion}
          sortable
          style={{ minWidth: "10rem" }}
        />
      ))}
      <Column
        header="Acciones"
        style={{ width: "8rem" }}
        body={(rowData) => (
          <Button
            icon="pi pi-cog"
            label="Configurar"
            className="p-button-sm p-button-outlined"
            onClick={(e) => {
              e.stopPropagation();
              onConfigurar?.(rowData);
            }}
            tooltip="Reconfigurar documentos de venta del cliente"
            tooltipOptions={{ position: "left" }}
          />
        )}
      />
    </DataTable>
  );
};

export default AgrupacionTable;